/**
 * <caos-localization-auto>: country and language as plain clickable text in the footer.
 *
 * The form is Shopify's own localization form, so it works on its own: pick a country, press
 * "Applica". That button is what makes the column look like a form, so as soon as this script runs
 * the element marks itself (data-auto="on", which hides the button in CSS) and sends the form the
 * moment a value changes. Without JavaScript nothing is hidden and nothing changes.
 */
class CaosLocalizationAuto extends HTMLElement {
  connectedCallback() {
    const form = this.querySelector('form');
    if (!form) return;

    this.dataset.auto = 'on';
    form.addEventListener('change', (event) => {
      if (event.target instanceof HTMLSelectElement) form.requestSubmit();
    });
  }
}

if (!customElements.get('caos-localization-auto')) {
  customElements.define('caos-localization-auto', CaosLocalizationAuto);
}
